/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_TitleInputs */

const vi_irrigation_devices_title = /** @type {(inputs: Irrigation_Devices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ phun nước`)
};

/**

* @param {Irrigation_Devices_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_title = /** @type {((inputs?: Irrigation_Devices_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_title(inputs)
});